import { render, staticRenderFns } from "./AdminOrderChat.vue?vue&type=template&id=32d2bece&scoped=true&"
import script from "./AdminOrderChat.vue?vue&type=script&lang=js&"
export * from "./AdminOrderChat.vue?vue&type=script&lang=js&"
import style0 from "./AdminOrderChat.vue?vue&type=style&index=0&id=32d2bece&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d2bece",
  null
  
)

export default component.exports